<div class="text-primary">
  <div class="p-0 d-flex flex-wrap flex-column justify-content-around align-items-center">
    <ng-container *ngIf="card$ | async as card">
      <ng-container *ngIf="member$ | async as member">
        <!-- Not Owner Barcode Body -->
        <div class="w-100 bg-primary barcode-content-container pt-3">
          <div class="barcode-content mx-3 pb-2 text-white">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <!--Name and ID-->
              <div class="card-id text-start">
                <h5 class="mb-1 card-name" *ngIf="memberDetails$ | async as memberDetails">
                  {{ memberDetails.FirstName }} {{ memberDetails.Surname | slice : 0 : 1 }}.
                </h5>
                <div class="d-flex font-size-14 card-details text-secondary">
                  <h4 class="mb-0">{{ card.ProductCode }}</h4>
                  <div class="px-1">-</div>
                  <h4 class="mb-0">{{ card.ExternalRefNumber }}</h4>
                </div>
              </div>
              <ng-container *ngIf="!isWalletPage">
                <div class="btn btn-secondary fw-bold d-flex align-items-center" [routerLink]="'/rewards/wallet'">
                  <span class="icon material-icons pe-2">account_balance_wallet</span>
                  <span> {{ 'barcode.wallet.button' | translate }} </span>
                </div>
              </ng-container>
            </div>

            <!--Barcode-->
            <ng-container *ngIf="isWalletPage">
              <div class="qr p-3 mb-3 bg-barcode d-flex justify-content-center rounded-4" >
               
                <!--Mobile Pass-->
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.mobile.pass'">
                  <ng-container *ngIf="member$ | async as member">
                    <fgb-mobile-pass [memberId]="member.MemberId"></fgb-mobile-pass>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>

            <ng-container *inPopulation="[populations.Paid, populations.Default]">
            <div class="card-user-details-section pb-2">
              <!-- <ng-container *inPopulation="[populations.Paid]">
                <div class="account-info">
                  <div class="discount mb-2 font-size-12">{{ 'member.card.discount' | translate }}</div>
                  <div class="text-start value">{{ card.RetailDiscountLevel || 0 }}%</div>
                </div>
              </ng-container> -->
                <div class="account-info">
                  <div class="points mb-2 font-size-12">{{ 'member.card.points' | translate }}</div>
                  <div class="value text-start">
                    {{ pointsBalance$ | async | number : '1.0-0' }}
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
